import React from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowBlue, IconArrowRight } from '../../assets/icons'
import { useResponsive } from '../../utils/hooks'
import { Text, TouchableOpacity, View } from 'react-native'
import { commonColors } from '../../../../common-frontend/src/theme'

interface EndIconProps {
  desktopView?: boolean
}

export const EndIcon: React.FC<EndIconProps> = ({ desktopView }) => {
  const { sm } = useResponsive()
  const { t } = useTranslation('global')
  return sm && desktopView ? (
    // eslint-disable-next-line i18next/no-literal-string
    <View pointerEvents="none">
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 4,
          borderColor: commonColors.accentText,
          borderWidth: sm && desktopView ? 1 : 0,
          paddingHorizontal: 15,
          paddingVertical: 8,
        }}
      >
        <Text
          style={{
            color: commonColors.accentText,
            fontWeight: '500',
            marginRight: 8,
          }}
        >
          {t('Connect')}
        </Text>
        <IconArrowRight fill={commonColors.accentText} width={15} height={15} />
      </TouchableOpacity>
    </View>
  ) : (
    <ArrowBlue />
  )
}
